<template>
  <v-img :src='require("@/assets/mmt_top_900x600.jpg")' class='top_bg'>
    <v-container d-flex justify-center class='header'>
      <v-container d-flex column class='header_content'>
        <v-container class='header_content_icon'>
          <v-img :src='require("@/assets/mmt_icon.png")' height='60' width='60'></v-img>
        </v-container>

        <v-container class='header_content_links font_caption'>
          <a v-for='link in links' :key='link.path' :href='`#${link.path}`'>{{ link.name }}</a>
        </v-container>
      </v-container>
    </v-container>

    <v-flex d-flex align-center justify-center column fluid class='top_logo'>
      <v-layout align-center justify-center column fill-height>
        <h1>Mastodon Meetup at Tokyo</h1>
        <p>
          2018.11.03(Sat) 14:00-<br>
          in 株式会社インターネットイニシアティブ 東京本社<v-icon>place</v-icon>
        </p>
      </v-layout>
    </v-flex>
  </v-img>
</template>

<script>
export default {
  name: 'eventtop',
  props: {},
  data: () => {
    return {
      links: [
        {
          name: 'About', path: 'about'
        },
        {
          name: 'Speaker', path: 'speaker'
        },
        {
          name: 'Schedule', path: 'schedule'
        },
        {
          name: 'Access', path: 'access'
        }
      ]
    };
  }
}
</script>

<style scoped>
  .top_bg {
    height: 400px;
  }

  .top_logo {
    height: 100%;
    color: rgb(52, 52, 52);
    text-align: center;
    margin: 0px 10px;
  }

  .top_logo h1 {
    letter-spacing: 0.2rem;
    font-size: 2.5rem;
    display: block;
  }

  .top_logo p {
    font-size: 1.3rem;
    margin-bottom: 0px;
    margin-top: 2rem;
    font-weight: bold;
  }

  .top_logo p i.v-icon {
    color: rgb(52, 52, 52);
  }

  .header {
    background-color: rgba(255, 255, 255, 0.5);
    height: 60px;
    padding: 0px;
    max-width: none;
  }

  .header_content {
    max-width: 600px;
    padding: 0px;
    margin: 0px 10px;
    color: rgb(52, 52, 52);
  }

  .header_content_icon {
    padding: 0px;
    flex: none !important;
    width: auto;
  }

  .header_content_links {
    padding: 0px;
    text-align: right;
  }

  .header_content_links > a {
    margin-left: 10px;
    color: rgb(52, 52, 52);
  }
</style>
